import { AbstractGame } from '@games/core';
import { BlindReadingExample, BlindReadingExampleFactory } from './example';
import { BlindReadingControllerComponent } from './blind-reading-controller/blind-reading-controller.component';
import { BlindReadingSettingsComponent } from './blind-reading-settings/blind-reading-settings.component';
import { BLIND_READING_PARAMETERS_DECLARATION } from './parameters';
import { READING_SHARED_PARAMETERS } from '@games/speed-reading/filter-parameters';
// import { BlindReadingExamplePreviewComponent } from './blind-reading-preview/blind-reading-example-preview/blind-reading-example-preview.component';
// import { BlindReadingCorrectAnswerPreviewComponent } from './blind-reading-preview/blind-reading-answer-preview/blind-reading-answer-preview.component';
// import { BlindReadingUserAnswerPreviewComponent } from './blind-reading-preview/blind-reading-user-answer-preview/blind-reading-user-answer-preview.component';
// import { BlindReadingParametersPreviewComponent } from './blind-reading-preview/blind-reading-parameters-preview/blind-reading-parameters-preview.component';

export const BlindReading: AbstractGame = {
  name: 'blind-reading',

  options: {},

  meta: {
    image: 'blind-reading.png',
    playerLines: 2,
    playerCount: 6,
  },

  parameters: BLIND_READING_PARAMETERS_DECLARATION,

  controllerComponent: BlindReadingControllerComponent,

  settingsComponent: BlindReadingSettingsComponent,

  // previews: {
  //   example: BlindReadingExamplePreviewComponent,
  //   correctAnswer: BlindReadingCorrectAnswerPreviewComponent,
  //   userAnswer: BlindReadingUserAnswerPreviewComponent,
  //   parameters: BlindReadingParametersPreviewComponent,
  // },

  example: BlindReadingExample,

  exampleFactory: BlindReadingExampleFactory,

  sharedParameters: {
    ...READING_SHARED_PARAMETERS,
  },

  tools: [],
};
